import React = require('react');
import { flow, get } from 'lodash';
import { connect } from 'react-redux';
import { IStore } from '../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import { actions as headerActions } from '../../../../services/header/reducer';
import { withRouter } from 'react-router';
import { FiHelpCircle, FiPhone } from 'react-icons/fi';
import { IChannel } from '../../../../data/api/models';
import { IAuthState } from '../../../../services/auth/models';
import { IHeaderActions } from '../../../../services/header/models';
import { MenuDropdown } from './Components/MenuDropdown';
import { MarketingUpsellModal } from '../../../../components/MarketingUpsellModal';
import { push } from 'react-router-redux';
import { actions as modalActions } from '../../../../services/modal/reducer';
import { IModalActions, IUpsellModal } from '../../../../services/modal/model';
import { IMtaActions } from '../../../../services/mta/models';
import { mtaActions } from '../../../../services/mta/actions';
import PortalHeader from '../PortalHeader';
import { useEffect, useState } from 'react';
import { IBrandingState } from '../../../../services/branding/models';

interface IPortalHeader {
  channel: IChannel;
  hideContactUsSelection: boolean;
  auth: IAuthState;
  openContactUsModal: boolean;
  upsellModal: IUpsellModal;
  branding: IBrandingState;
  actions: {
    auth: IAuthActions;
    header: IHeaderActions;
    push: (route: string) => void;
    modal: IModalActions,
    mta: IMtaActions
  }
}

const PortalNavBar = ({
                        auth,
                        upsellModal,
                        branding,
                        actions
                      }: IPortalHeader) => {

  const hideFAQ = false
  const isAuthenticated = get(auth, 'isAuthenticated', false);
  const [loading, setLoading] = useState(true)
  const isContactUsEnabled = get(branding, 'channel.products[0].metadata.direct_customer_mta_options.other.enable_contact_us', true)

  useEffect(() => {
    setLoading(false)
  }, [])

  if (loading) {
    return null;
  }

  const handleOnclick = () => {
    actions.push('/account/summary')
  }

  return (
    <div className={'nav-page'}>
      <div className="portal-top-nav-container">
        <div className="portal-top-nav">
          <div className="container">
            <div className={'top-nav-container'}>
              <div className="portal-logo-container">
                <div className="logo-link" onClick={handleOnclick} style={{ cursor: 'pointer' }}>
                  <img src={require('../../Img/admiral_logo.png')} alt="Admiral"/>
                </div>
                <div className="logo-divider"/>
                <div className="logo-title">Travel</div>
              </div>
              <div className="nav-elements-container">
                {!hideFAQ && isAuthenticated && (
                  <div className={'nav-elements'}>
                    <a href={'https://www.admiral.com/travel-insurance/FAQs'} target={'_blank'}>
                      <FiHelpCircle className="portal-top-nav__icon"/>FAQ
                    </a>
                  </div>
                )}

                {isContactUsEnabled && (
                  <div className="nav-elements pointer">
                    <a href={'https://www.admiral.com/contact-us/travel'} target={'_blank'}>
                      <FiPhone className="portal-top-nav__icon"/>Contact Us
                    </a>
                  </div>
                )}

                {isAuthenticated && (
                  <MenuDropdown actions={actions}/>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {isAuthenticated && (
        <>
          <MarketingUpsellModal
            push={actions.push}
            upsellModal={upsellModal}
            modalActions={actions.modal}
            mtaActions={actions.mta}
          />
          <PortalHeader/>
        </>
      )}
    </div>
  )
};

export default flow([
  connect(
    (state: IStore) => ({
      auth: state.auth,
      openContactUsModal: state.header.isContactUsModalOpened,
      upsellModal: state.modal.upsellModal,
      branding: state.branding,
    }),
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        auth: bindActionCreators({ ...authActions }, dispatch),
        modal: bindActionCreators({ ...modalActions }, dispatch),
        header: bindActionCreators({ ...headerActions }, dispatch),
        mta: bindActionCreators({ ...mtaActions }, dispatch),
      },
    }),
  ),
  withRouter,
])(PortalNavBar);
